module.exports = __webpack_public_path__ + "static/media/lysithea-vonordelia-win.f3f077b9.png";